import { tv } from 'tailwind-variants';

export const lookerStyle = tv({
  slots: {
    headline: `
        mb-2
        text-center
        text-base
    `,
    table: `
        w-full
        table-fixed
    `,
    tableHead: `
        sticky
        top-0
    `,
    tableHeader: `
        !px-1
        !text-xs
        !text-gray-600
    `,
    tableRow: `
        group
        hover:bg-gray-50
    `,
    tableCell: `
        !px-1
        !text-xs
        group-last:!border-b-0
    `,
  },
});
